module.exports = __webpack_public_path__ + "img/fenice1-min.239ce470.jpg";